<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			<!-- <Button type="primary" @click="add">新增</Button>
			<Button type="info" @click="cold">冷藏/常温</Button>
			<Button type="success" @click="start">启用/禁用</Button> -->
		</div>
		<div class="btn">
			<RadioGroup v-model="animal">
				<Radio label="列表"></Radio>
				<Radio label="地图"></Radio>
			</RadioGroup>
		</div>
		<div  class="lb" v-if="animal=='列表'">
			<div class="query">
				<div class="checkbox">
					
				</div>
				<Input search enter-button placeholder="请输入地址/名称查询" v-model="query.like" style="width: 500px;" @on-search="onsearch"  />
			</div>
			<Table border :columns="columns12" :data="data6" :loading="loading" @on-selection-change="selectionChange">
				<template slot-scope="{ row, index }" slot="action">
					<Button size="small" style="margin-right: 5px" @click="aisleList(row.id)" type="primary">货道信息</Button>
					<Button @click="forbidden(row.id)" size="small" style="margin-right: 5px" class="delete">停用/启用</Button>
					<Modal v-model="modal2" width="360">
						<p slot="header" style="color:#f60;text-align:center">
							<Icon type="ios-information-circle"></Icon>
							<span>停用或启用设备</span>
						</p>
						<div style="text-align:center">
							<p>确定修改？</p>
						</div>
						<div slot="footer">
							<Button type="error" size="large" long :loading="modal_loading" @click="remove()">确定</Button>
						</div>
					</Modal>
					<Button size="small" style="margin-right: 5px" @click="forbidden3(row.id)" type="error" v-show="row.macContractStateName=='YC'">使用</Button>
					<Button size="small" style="margin-right: 5px" @click="forbidden3(row.id)" type="error" v-show="row.macContractStateName!='YC'">移除</Button>
					<Modal v-model="modal3" width="360">
						<p slot="header" style="color:#f60;text-align:center">
							<Icon type="ios-information-circle"></Icon>
							<span>修改状态</span>
						</p>
						<div style="text-align:center">
							<p>确定修改？</p>
						</div>
						<div slot="footer">
							<Button type="error" size="large" long :loading="modal_loading3" @click="yichu()">确定</Button>
						</div>
					</Modal>
				</template>
			</Table>
			<div class="my-page">
				<page v-if="showPage" :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
			</div>
		</div>
		
		<div class="ditu" v-else>
			<ditu :zxd="zxd" :qt="qt"></ditu>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	import ditu from '@/components/comm/ditu/ditu.vue'
	export default {
		data() {
			return {
				showPage:true,
				animal: '列表',
				//地图
				zxd: [106.49275526969987, 29.61166095192132], //中心点坐标
				qt: [
					/* {position: [121.5263285, 31.21415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'},
					{position: [121.5273285, 31.29415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'} */
				],
				//地图
				//查询条件
				wd: [],
				zt: [],
				gz: [],
				loading: false,
				total: 100,
				query: {
					page: '0',
					size: '10',
					id: '' //加盟商id
				},
				columns12: [ {
						title: 'id',
						key: 'id'
					},{
						title: '订单id',
						key: 'orderId'
					}, {
						title: '编号',
						key: 'macCode'
					},
					
					{
						title: '名称',
						key: 'macName'
					},
					
					{
						title: '所属加盟商',
						key: 'alliance',
						render: (h, params) => {
								return h("div", params.row.alliance.companyName)
						}
					},
					{
						title: '位置',
						key: 'address'
					},
					{
						title: '停用/启用',
						key: 'startUsing',
						render: (h, params) => {
							if (params.row.startUsing == true) {
								return h("div", "启用")
							} else {
								return h("div",{style:{color:'red'}},"停用") 
							}
						}
					},
					{
						title: '是否故障',
						key: 'state',
						render: (h, params) => {
							if (params.row.state == true) {
								return h("div", "正常")
							} else {
								return h("div",{style:{color:'red'}},"故障") 
							}
						}
					},
					{
						title: '状态',
						key: 'macContractStateString',
						render: (h, params) => {
							if (params.row.macContractStateName == 'WC') {
								return h("div", {style:{color:'green'}},params.row.macContractStateString)
							} else if(params.row.macContractStateName == 'YC') {
								return h("div",{style:{color:'red'}},params.row.macContractStateString) 
							} else{
								return h("div",{style:{color:'blue'}},params.row.macContractStateString) 
							}
						}
					},
					{
						title: '货道总数',
						key: 'total'
					},
					{
						title: '未分配数',
						key: 'isNull'
					},
					{
						title: '已分配数',
						key: 'isNotNull'
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}
				],
				data6: [{
					id: '1',
					machineCode: '',
					macName: 18,
					region: '',
					macTypeName: '饮料机',
					address: '渝北区泰山大道',
					ip: '192.168.10.1',
					startUsing: '启用',
					isRefrigerate: '冷藏',
					state: '正常',
					createdTime: '2010-10-10'
				}],
				deleteId: '',
				modal2: false,
				modal_loading: false,
				modal3: false,
				modal_loading3: false,

			}
		},
		methods: {
			
			onsearch(){
				let _this=this
				_this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			},
			yichu(){
				let _this=this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/leave/factory/updateMacContractState',
					data: {id: _this.deleteId},
					_this: _this,
					success: function(data) {
						_this.modal_loading3 = false;
						_this.modal3 = false;
						_this.$Message.success('修改成功！！！');
						_this.ajaxPage()
					}
					//假设后台需要的是表单数据这里你就可以更改
				  })
			},
			selectionChange(selections) { //选中项发生变化时就会触发
				console.log(selections)
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			forbidden(id) {
				this.deleteId = id
				this.modal2 = true
			},
			forbidden3(id) {
				this.deleteId = id
				this.modal3 = true
			},
			remove(id) { //删除
			    let _this=this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/leave/factory/update/startusing',
					data: {id: _this.deleteId},
					_this: _this,
					success: function(data) {
						_this.modal_loading = false;
						_this.modal2 = false;
						_this.$Message.success('修改成功！！！');
						_this.ajaxPage()
					}
					//假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			aisleList(id) { //设备货道信息
				this.$router.push({
					name: 'jm/platform/alliance/mac/aisle/list',
					query: {
						id: id,//设备id
						allianceId:this.query.id//加盟商id
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/jm/alliance',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macLeaveFactorys.totalElements
						_this.data6 = data.macLeaveFactorys.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			ajaxPageDitu() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/jm/alliance',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						let a = data.macLeaveFactorys.content
						console.log(a)
						for (var i = 0; i < a.length; i++) {
							let latitude = parseFloat(a[i].latitude)
							let longitude = parseFloat(a[i].longitude)
							let b = {
								position: [longitude, latitude],
								id: a[i].id,
								url: '/main/jm/platform/allianceMacAisle/list',
								address: a[i].address,
								code: a[i].macCode,
							}
						    console.log(b)
							_this.qt.push(b)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}

		},
		components: {
			page,ditu
		},
		created() {
			let allianceId = this.$route.query.id
			if (allianceId == undefined || allianceId == null || allianceId == "") {

				this.$Message.error('参数错误，请刷新页面!');
				return;
			}
			this.query.id = allianceId
			this.ajaxPage()
			this.ajaxPageDitu()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/alliance/mac/list.vue